import React from 'react';

import Heading from '@atlaskit/heading';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import { N30A } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import FeedbackModal from './feedback-modal';

const dividerStyles = xcss({
	marginBlock: 'space.100',
	marginInline: 'space.0',
	border: 0,
	borderBlockEnd: `2px solid ${token('color.border', N30A)}`,
});

interface FeedbackSectionProps {
	pageUrl: string;
	subpageTabName?: string;
	tabName?: string;
	title: string;
}

/**
 * __Feedback section__
 */
const FeedbackSection = ({ pageUrl, subpageTabName, tabName, title }: FeedbackSectionProps) => {
	return (
		<Stack space="space.050">
			<Box as="hr" xcss={dividerStyles} />
			<Inline space="space.200" alignBlock="center">
				<Heading size="xsmall">Was this page helpful?</Heading>
				<FeedbackModal
					pageUrl={pageUrl}
					subpageTabName={subpageTabName}
					tabName={tabName}
					title={title}
				/>
			</Inline>
			<Text color="color.text.subtle">We use this feedback to improve our documentation.</Text>
		</Stack>
	);
};

export default FeedbackSection;
